__turbopack_context__.v({
  "animatedBg": "styles-module-scss-module__egqjSa__animatedBg",
  "disable": "styles-module-scss-module__egqjSa__disable",
  "pulse": "styles-module-scss-module__egqjSa__pulse",
  "root": "styles-module-scss-module__egqjSa__root",
  "text": "styles-module-scss-module__egqjSa__text",
});
